import React from 'react';
import ServicesTable from '@modules/services/components/services-table/services-table.tsx';

const Services = () => {
  return (
    <div className="w-full h-full">
      <ServicesTable />
    </div>
  );
};

export default Services;
